module.exports = __webpack_public_path__ + "school-top.af2e844c7427cd52c52a.png";


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/assets/img/school-top.png
// module id = ../../../../../src/assets/img/school-top.png
// module chunks = main